import React from 'react'
import { componentPermissions } from 'config/permissions'
import { componentNames } from 'config/roles'
import { FC } from 'react'
import { RoutePaths } from 'routes/paths'
import { ContentBody } from 'components/pages/components/ContentBody'
import { IAccordionData, DynamicAccordion } from './components/DynamicAccordion'
import { DataQualityAssurancData } from './Data/DataQualityAssurance'


const DataQualityAssurance: FC = () => {
  return (
    <>
      <ContentBody title="knowledgeHub.dataQualityAssurance">
        {DataQualityAssurancData.map((d: IAccordionData, key: number) => (
          <DynamicAccordion data={d} index={key} key={key} />
        ))}
      </ContentBody>
    </>
  )
}

const exportObj = {
  routeProps: {
    // This gets passed straight to react-router
    path: [RoutePaths.knowledgeHubDataQualityAssurance],
    title: 'knowledgeHub.dataQualityAssurance',
    element: <DataQualityAssurance />,
    roles:
      componentPermissions[componentNames.pageKnowledgeHubDataQualityAssurance],
    requiresAuthentication: true,
  },
  name: 'DataQualityAssurance',
}
export default exportObj
